// extracted by mini-css-extract-plugin
module.exports = {"Navbar":"Navbar_Navbar__1IxrI","logo":"Navbar_logo__1H3m4","Navbar__menu":"Navbar_Navbar__menu__3HYRU"};